import gql from 'graphql-tag'
import { RegistrationFieldsFragment } from './registration'

export const REGISTRATION_QUERY = gql`
  query GatheringRegistrations($gatheringId: Int!) {
    gatheringRegistrations(gatheringId: $gatheringId) {
      ...RegistrationFields
    }
  }

  ${RegistrationFieldsFragment}
`
